// Dil tercihinin saklandığı depo.
//
// `localStorage`ı doğrudan geçmek yerine bir sarmalayıcı: tarayıcı dışı
// bağlamlarda (test, olası SSR/prerender) `localStorage` tanımsızdır ve
// erişimin kendisi ReferenceError atar — okuma denemesinden ÖNCE eleriz.
// Depo çalışma zamanında patlarsa (private mode, kota) SDK tarafı zaten
// yutuyor; buradaki kontrol yalnızca "hiç yok" durumu için.

import type { LocaleStorage } from "@novemai/i18n-sdk";

export const localeStorage: LocaleStorage | undefined =
  typeof window === "undefined" || typeof window.localStorage === "undefined"
    ? undefined
    : window.localStorage;
